<template>
  <v-container>
    <ContentHeader
      header-icon="mdi-test-tube"
      header-title="QA"
      back-navigation
      back-navigation-href="/admin"
      back-navigation-text="To Old Admin"
    >
    </ContentHeader>

    <v-container>
      <v-tabs v-model="activeTab">
        <v-tab
          v-for="tab in tabs"
          :key="`${tab.name}-tab`"
          :to="`#${tab.route}`"
          >{{ tab.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item
          v-for="tab in tabs"
          :key="`${tab.name}-tabitem`"
          :value="tab.route"
        >
          <component
            :is="tab.component"
            :is-active="activeTab === tab.route"
            class="mt-4"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-container>
</template>

<script>
import QASubscriptions from "./QASubscriptions.vue";
import ContentHeader from "@/views/ContentHeader.vue";
import QATestFiles from "@/views/qa/QATestFiles.vue";
import QARunnables from "@/views/qa/QARunnables.vue";

const tabs = [
  {
    name: "Subscriptions",
    route: "subscriptions",
    component: QASubscriptions
  },
  {
    name: "Test Files",
    route: "test-files",
    component: QATestFiles
  },
  {
    name: "Runnables",
    route: "runnables",
    component: QARunnables
  }
];

export default {
  name: "QA",
  components: { ContentHeader },
  data: () => ({
    tabs,
    activeTab: null
  })
};
</script>
<style lang="scss" scoped>
::v-deep .v-tabs-bar {
  background-color: transparent !important;
}
</style>
